import React from "react";
import styles from "./card.module.scss";

type Props = {
  children?: React.ReactNode;
  onClick?: () => void;
};

export const Card = ({ children, onClick }: Props) => {
  return (
    <div onClick={onClick} className={styles.card}>
      {children}
    </div>
  );
};
